import React from 'react';
import { Link } from 'react-router';
import '../../../public/css/media/_cart.scss';
import { disabledCart } from '../../utils/utils';

const DashboardNavigation = (props) =>
  <ul className="main-nav">
    <li>
      <Link
        to={disabledCart && !props.enabledCart ? props.prevPath.pathname : '/cart'} 
        className={disabledCart ? 'isDisabled' : ''} 
        activeClassName={disabledCart ? '' : 'active'}>
        Cart
      </Link>
    </li>
    {
      props.fetchCart ? null
        : props.offsize && props.offsize.length > 0 ?
          <li>
            <Link to="/offsize" activeClassName="active">
              Off-size Items
            </Link>
          </li>
      : null
    }
    {
      props.fetchProhibited ? null
        : props.prohibited ? props.prohibited.data.length > 0 ?
          <li>
            <Link to="/prohibited" activeClassName="active">
              <i className="prohibited-alert fa fa-exclamation-triangle" /> Prohibited Items
            </Link>
          </li>
        : null
      : null
    }
    {[
      { route: '/shipment', label: 'Shipments' },
      { route: '/account', label: 'Account' },
    ].map((link,i) => (
      <li key={i}>
        <Link
          to={disabledCart && !props.enabledCart && link.route === '/cart' ? props.prevPath.pathname : link.route} 
          className={disabledCart && link.route === '/cart' ? 'isDisabled' : ''} 
          activeClassName={disabledCart && link.route === '/cart' ? '' : 'active'}>
          {link.label}
        </Link>
      </li>
    ))}
  </ul>

export default DashboardNavigation;



/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/DashboardNav.js
 **/